import {treeForEach} from 'utils'
import {createProjectModel} from 'crm/utils/project-model'
import {
    config,
    setConfig,
    currentTree,
    groups,
    stores,
    sync,
    syncStatus,
    syncGroupCode,
    updateStoreGroupCode,
    storeDrainageUsers,
    downloadTemplate,
    importGroupLink,
    updateFullUsers,
    downloadFullUsers,
} from './service/store-management'

function getInitialSearchParams() {
    return {
        keyword: undefined, // 门店名称
        community_empty: undefined,
        community_qrcode_url_empty: undefined,
        charge_user_empty: undefined,
        drainage_user_empty: undefined,
        drainage_user_empty_and_qrcode: undefined,
        group_id: undefined, // 分组ID
        limit: 10,
        offset: 0,
    }
}

const model = createProjectModel({
    projectNamespace: 'storeManagement',
    state: {
        groups: [],
        groupExpandedKeys: [],
        groupSelectedKey: undefined,
        groupSelectedLabel: '',
        params: {
            group_id: undefined, // 分组id
            ...getInitialSearchParams(),
        },
        stores: [],
        total: 0,
        current: 1,
        abnormalStat: null,
        taskUpdateFullUsersId: null,
    },
    effects: {
        *config({payload}, {call, put}) {
            const res = yield call(config, payload)
            const rootDepartmentId = res?.data?.root_department_id
            yield put({
                type: 'setProperty',
                payload: {
                    groupSelectedKey: rootDepartmentId,
                },
            })
            return rootDepartmentId
        },
        *setConfig({payload}, {call}) {
            return yield call(setConfig, payload)
        },
        *departmentTree({payload}, {call}) {
            return yield call(currentTree, payload)
        },
        *groups({payload}, {call, put}) {
            const res = yield call(groups, payload)
            if (res && res.data) {
                const {data} = res
                treeForEach(data, (item, parent) => {
                    // eslint-disable-next-line no-param-reassign
                    // item.level = parent?.level ? ++parent.level : 1
                    item.parent = parent
                })

                yield put({
                    type: 'setProperty',
                    payload: {
                        groups: data,
                    },
                })

                if (payload.initial) {
                    const groupExpandedKeys = data.map((item) => String(item.id))
                    yield put({
                        type: 'setProperty',
                        payload: {
                            groupExpandedKeys,
                            groupSelectedKey: data[0]?.id,
                            groupSelectedLabel: data[0]?.name,
                        },
                    })
                }
                return data
            }
        },
        // 门店
        *stores({payload}, {call, put, select}) {
            const {params, groupSelectedKey} = yield select((allState) => allState[model.namespace])

            const newParams = {...params, group_id: groupSelectedKey}
            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }

            const res = yield call(stores, newParams)

            yield put({
                type: 'setProperty',
                payload: {
                    params: newParams,
                    stores: res.data,
                    total: res?.pagination?.rows_found || 0,
                    current:
                        Math.trunc(
                            (res?.pagination?.offset || 0) / (res?.pagination?.limit || 10),
                        ) + 1,
                },
            })
        },
        *sync({payload}, {call}) {
            return yield call(sync, payload)
        },
        *syncGroupCode({payload}, {call}) {
            return yield call(syncGroupCode, payload)
        },
        *syncStatus({payload}, {call}) {
            return yield call(syncStatus, payload)
        },
        *updateStoreGroupCode({payload}, {call}) {
            return yield call(updateStoreGroupCode, payload)
        },
        *storeDrainageUsers({payload}, {call}) {
            return yield call(storeDrainageUsers, payload)
        },
        *downloadTemplate({payload}, {call}) {
            return yield call(downloadTemplate, payload)
        },
        *importGroupLink({payload}, {call}) {
            return yield call(importGroupLink, payload)
        },
        *updateFullUsers({payload}, {call}) {
            return yield call(updateFullUsers, payload)
        },
        *downloadFullUsers({payload}, {call}) {
            return yield call(downloadFullUsers, payload)
        },
    },
    reducers: {
        resetSearchParams(state) {
            return {
                ...state,
                params: {
                    ...state.params,
                    ...getInitialSearchParams(),
                },
            }
        },
    },
})

export default model
